module.exports = __webpack_public_path__ + "img/operate-4.7997650d.gif";